"use client";

import { Box, Flex, Icon } from "@chakra-ui/react";
import { HiOutlineChevronRight } from "react-icons/hi2";
import { Link, Text } from "@/components/ui";
import { useThemeTokens } from "@/lib/theme/tokens";

export function PublicDetailBreadcrumbs({
  parentHref,
  parentLabel,
  currentLabel,
}: {
  parentHref: string;
  parentLabel: string;
  currentLabel: string;
}) {
  const theme = useThemeTokens();

  return (
    <Box as="nav" aria-label="Breadcrumb" minW={0}>
      <Flex
        as="ol"
        listStyleType="none"
        m={0}
        p={0}
        align="center"
        gap={2}
        minW={0}
        fontSize="sm"
        fontWeight="500"
      >
        <Box as="li" flexShrink={0}>
          <Link
            href={parentHref}
            color={theme.text.primary}
            _hover={{ textDecoration: "none" }}
            sx={{
              "@media (hover: hover)": {
                "&:hover": { color: theme.accent.primary },
              },
            }}
          >
            {parentLabel}
          </Link>
        </Box>
        <Box as="li" display="flex" flexShrink={0} aria-hidden>
          <Icon
            as={HiOutlineChevronRight}
            boxSize="14px"
            color={theme.text.tertiary}
          />
        </Box>
        <Box as="li" minW={0}>
          <Text
            as="span"
            noOfLines={1}
            color={theme.text.secondary}
            aria-current="page"
          >
            {currentLabel}
          </Text>
        </Box>
      </Flex>
    </Box>
  );
}
